<div oui-dialog-title>
  Envoyer une demande de renouvellement
  <oui-button class="dialog-close-btn" type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content class="dialog-content">
  @if (isLoading()) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  } @else {
    <div class="dialog-body">
      <span
        >Vous êtes sur le point d'envoyer un email pour demander le renouvellement d'un
        document: {{ data.documentName }}</span
      >
    </div>
  }
</oui-dialog-content>

<oui-dialog-actions class="dialog-actions">
  <oui-button type="text" oui-dialog-close>Annuler</oui-button>
  <oui-button (click)="confirm()">Valider</oui-button>
</oui-dialog-actions>
